import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../index';
import { getSynchronisationlogs } from 'api/synchronisationlogs';

const initialState = {
    logsPaginated: {
        data: [],
        count: 0
    },
    isFetching: false
};

const slice = createSlice({
    name: 'synchronisationlog',
    initialState,
    reducers: {
        setLogsPaginated(state, action) {
            state.logsPaginated = action.payload;
        },
        setIsFetching(state, action) {
            state.isFetching = action.payload;
        }
    }
});

export const { setLogsPaginated, setIsFetching } = slice.actions;

export default slice.reducer;

export function fetchSynchronisationlogsPaginated(params) {
    return async () => {
        try {
            dispatch(slice.actions.setIsFetching(true));
            const result = await getSynchronisationlogs(params);
            dispatch(
                slice.actions.setLogsPaginated({
                    data: result?.data?.list || [],
                    count: result?.data?.summary?.total || 0
                })
            );
        } catch (error) {
            console.error('fetchSynchronisationlogsPaginated error:', error);
            dispatch(
                slice.actions.setLogsPaginated({
                    data: [],
                    count: 0
                })
            );
        } finally {
            dispatch(slice.actions.setIsFetching(false));
        }
    };
}
